export default __webpack_public_path__ + "static/media/image-white.92722aeb.jpg";